import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonItem, IonLabel, IonAvatar, IonBadge } from '@ionic/angular/standalone';
import { User } from '@crowdctrl/core';

@Component({
  selector: 'crowdctrl-tenant-user-item',
  standalone: true,
  imports: [CommonModule, IonItem, IonLabel, IonAvatar, IonBadge],
  templateUrl: './tenant-user-item.component.html',
  styleUrl: './tenant-user-item.component.css',
})
export class TenantUserItemComponent {
  @Input() user!: User;
  @Input() button = false;
  @Input() detail = false;
  @Input() disabled = false;
  @Input() disabledMessage?: string;

  getUserDisplayName(user: User): string {
    return user.email || 'Unknown User';
  }
}
